import { Link } from "react-router-dom";
import { BookOpen, ArrowUpRight } from "lucide-react";
import { useCMS } from "@/hooks/useCMS";
import { useLang } from "@/context/LanguageContext";
import { Eyebrow, Reveal } from "@/components/motifs";
import { imgStyle } from "@/lib/imagePos";

export default function Blog() {
  const { data } = useCMS();
  const { t } = useLang();
  const s = data.settings || {};
  const articles = data.articles || [];
  const per = Number(s.articles_per_row) || 3;
  const cols = per === 2 ? "sm:grid-cols-2" : per === 4 ? "sm:grid-cols-2 lg:grid-cols-4" : "sm:grid-cols-2 lg:grid-cols-3";

  return (
    <div data-testid="blog-page">
      <section className="mx-auto max-w-7xl px-4 sm:px-8 pt-14 pb-10 lg:pt-20">
        <Eyebrow icon={BookOpen}>{t("Blog", "Blogue")}</Eyebrow>
        <h1 className="mt-4 font-display font-black uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">{s.blog_title || "Stories in Motion"}</h1>
        {s.blog_intro && <p className="mt-5 max-w-2xl text-lg text-muted-foreground">{s.blog_intro}</p>}
      </section>

      <section className="mx-auto max-w-7xl px-4 sm:px-8 pb-20">
        {articles.length === 0 ? (
          <p className="text-muted-foreground" data-testid="blog-empty">{t("No articles published yet.", "Aucun article publié pour l'instant.")}</p>
        ) : (
          <div className={`grid gap-8 ${cols}`}>
            {articles.map((a, i) => (
              <Reveal key={a.id || i} delay={(i % 3) * 0.08}>
                <Link to={`/Blog/${a.slug}`} className="group flex h-full flex-col overflow-hidden rounded-3xl border border-border bg-card hover:shadow-xl hover:-translate-y-1 transition-all duration-300" data-testid={`blog-card-${i}`}>
                  <div className="relative h-52 overflow-hidden">
                    <img src={a.cover} alt={a.cover_alt || a.title} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" style={imgStyle(a, "cover")} />
                    {a.category && <span className="absolute top-4 left-4 rounded-full px-3 py-1.5 text-xs font-black uppercase text-white shadow" style={{ background: a.accent || "#2CACD4" }}>{a.category}</span>}
                  </div>
                  <div className="flex flex-1 flex-col p-6">
                    <p className="text-xs uppercase tracking-wider text-muted-foreground">{[a.author, a.date].filter(Boolean).join(" · ")}</p>
                    <h2 className="mt-2 font-display font-black uppercase text-xl leading-tight group-hover:text-[#2CACD4] transition-colors">{a.title}</h2>
                    <p className="mt-2 text-sm text-muted-foreground line-clamp-3 flex-1">{a.excerpt}</p>
                    <span className="mt-4 inline-flex items-center gap-1 text-sm font-bold">{t("Read", "Lire")} <ArrowUpRight size={15} /></span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
